import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { AddressModel, getFormattedAddress } from '@steelbuy/ts-shared';
import './Address.scss';

interface AddressProps {
    addressModel?: AddressModel;
    phoneNumber?: string;
}

export const Address = ({ addressModel, phoneNumber }: AddressProps) => {
    const { t }: { t: TFunction } = useTranslation('domainModel');
    const formattedAddress = addressModel && getFormattedAddress(addressModel);
    return (
        <article className="address">
            <span>{addressModel?.organisation.name}</span>
            {formattedAddress?.map(({ value, id, isEnum }) => (
                <span key={id}>{isEnum ? t(`${value}`) : value}</span>
            ))}
            {phoneNumber && <span>{phoneNumber}</span>}
        </article>
    );
};
